<template>
  <CrudForm :title="title" :labelSubmit="label_submit" :storeName="storeName" parentStoreName="Users" :submit="submit"
    :status="status" :canCancel="false" :breadcrumbs="[
      {
        text: 'Marketing y comunicación',
        disabled: false,
        href: '/admin/push_notifications'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row no-gutters justify="center">
        <v-col cols="6">
          <v-row no-gutters>
            <v-col cols="12">
              <ValidationProvider ref="name" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Segmento</div>
                <v-select solo hide-details="auto" class="input-base" :error-messages="errors" v-model="data.type"
                  label="Segmento" :items="types" append-icon="$caretDownFormIcon">
                  <template slot="no-data">
                    <v-alert :value="true"> There is no info to show </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
            <v-col cols="12">
              <ValidationProvider ref="user" :rules="selectAll ? '' : 'required'" v-slot="{ errors }">
                <div class="label-base pb-1">Users</div>
                <v-select append-icon="$caretDownFormIcon" solo hide-details="auto" class="input-base"
                  :error-messages="errors" v-model="data.users" :items="usersCopy" attach :loading="loading"
                  label="Users" :item-text="(row) => `${row.name || ''} ${row.last_name || ''}`
                    " :disabled="!data.type || loading" item-value="_id" multiple search-input>
                  <template #label>
                    <span v-if="selectAll" class="fixed-label-">{{ usersCopy.length }} usuarios seleccionados</span>
                    <span v-else class="fixed-label-">Users</span>
                  </template>
                  <template #selection="{ item, index }">
                    <span v-if="index === 0">
                      {{ data.users.length }} usuarios seleccionados
                    </span>
                  </template>
                  <template #prepend-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-text-field v-model="searchUser" placeholder="Search" @input="searchUsers"></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                    <v-list-item @click="clickSelectAll()">
                      <v-list-item-action>
                        <v-checkbox v-model="selectAll" :indeterminate="selectAll === null" :input-value="false"
                          hide-details @change="clickSelectAll()" :disabled="usersCopy.length === 0"></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Seleccionar todos</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <template #progress>
                    <!-- <v-progress-circular
                      :v-model="percent_segment"
                      :rotate="360"
                      :size="50"
                      :width="10"
                      color="teal"
                    >
                      <template v-slot:default> <small>{{ percent_segment }} %</small> </template>
      </v-progress-circular> -->
                    <v-progress-linear v-model="percent_segment" color="light-blue" height="15" class="mt-10" striped
                      style="position: absolute !important; top: 0;">
                      <template v-slot:default="{ value }">
                        <strong class="text-caption">{{ Math.ceil(value) }}% Cargando...
                        </strong>
                      </template>
                    </v-progress-linear>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider ref="title" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Title</div>
                <v-text-field label="Title" :error-messages="errors" v-model="data.title" solo hide-details="auto"
                  class="input-base" />

                <!--                <v-textarea
                  :error-messages="errors"
                  v-model="data.question"
                  solo
                >
                </v-textarea>-->
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider ref="answer" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Body Push</div>
                <v-textarea :error-messages="errors" v-model="data.body_push" solo placeholder="Descripción"
                  hide-details="auto" class="text-tarea-base" rows="8">
                </v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider ref="send_email" rules="" v-slot="{ errors }">
                <v-checkbox :error-messages="errors" v-model="data.send_email" label="Enviar como email" value="on"
                  class="input-check-base mt-5" hide-details="auto" on-icon="$checkedIcon"
                  off-icon="$unCheckedIcon"></v-checkbox>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters v-if="data.send_email">
            <v-col>
              <ValidationProvider ref="title_email" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Title Email</div>
                <v-text-field label="Title Email" :error-messages="errors" v-model="data.title_email" solo
                  hide-details="auto" class="input-base" />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters v-if="data.send_email">
            <v-col>
              <ValidationProvider ref="answer" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Body Email</div>
                <v-textarea :error-messages="errors" v-model="data.body_email" solo placeholder="Descripción"
                  hide-details="auto" class="text-tarea-base" rows="8">
                </v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider ref="url" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Url</div>
                <v-text-field label="Url" :error-messages="errors" v-model="data.url" solo hide-details="auto"
                  class="input-base" />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider ref="picture" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Imagen perfil</div>
                <Upload :error-messages="errors" accept="image/png, image/jpeg, image/jpg"
                  placeholder="Imagen de Perfil" prepend-icon="fas fa-camera" label="" :multiple="false"
                  :onSelectedPicture="onSelectedPicture"></Upload>
                <v-img :src="picture" width="200" style="margin: auto"></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import swal from "sweetalert";

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, Upload, CrudForm },
  computed: {
    ...mapState({
      status: (state) => state.Faqs.status,
      users: (state) => state.Users.list,
      percent: (state) => {
        const load = state.Users.loading_percent;
        return load;
      },
    }),
  },
  watch: {
    "data.users"(newValue) {
      if (newValue.length === 0) {
        // this.selectAll = false;
      } else if (newValue.length === this.usersCopy.length) {
        this.selectAll = true;
      } else {
        this.selectAll = null; // indeterminado si selecciona algunos
      }
    },
    "data.type": {
      async handler(newValue) {
        const self = this;
        this.loading = true;

        // Reset search and selection
        this.searchUser = "";
        this.selectAll = false;
        this.data.users = [];

        this.data.users = [];
        let filter_type = { type: newValue };
        if (newValue === "all_users") {
          filter_type = {};
        }
        await this.$store.dispatch("Users/getListAll", {
          show_all: "enable",
          ...filter_type,
          sorting_column: "name",
          sorting_order: "asc",
        });
        this.usersCopy = this.users;

        setTimeout(() => {
          self.loading = false;
        }, 2000);
      },
    },
    percent(newValue) {
      this.percent_segment = newValue;
    },
  },
  /*  async created() {
    await this.$store.dispatch("Users/getListAll", {
      show_all: "enable",
      sorting_column: "name",
      sorting_order: "asc",
    });
    this.usersCopy = this.users;
  }, */
  data() {
    return {
      storeName: "Push_notifications",
      label_submit: "Send Notification",
      title: "Notificaciones",
      show: true,
      filteredAttributes: ["picture"],
      picture: "",
      types: [
        {
          text: "HOSTS",
          value: "host",
        },
        {
          text: "HOSTS QUE TIENEN AUTO",
          value: "host_with_car",
        },
        {
          text: "CONDUCTORES",
          value: "driver",
        },
        {
          text: "USUARIOS QUE NO TIENEN NI AUTO NI SPOT",
          value: "user_without_car_and_spot",
        },
        {
          text: "USUARIOS NUEVOS DEL DÍA‌",
          value: "new_user",
        },
        {
          text: "USUARIOS CON SPOT RECHAZADO‌",
          value: "user_with_rejected_spot",
        },
        {
          text: "TODOS LOS USUARIOS",
          value: "all_users",
        },
      ],
      data: {
        title: "",
        body_push: "",
        body_email: "",
        users: [],
        picture: undefined,
        type: "",
        send_email: "",
        title_email: "",
        // is_new: true,
      },
      selectAll: false,
      searchUser: "",
      usersCopy: [],
      loading: false,
      percent_segment: 0,
    };
  },

  methods: {
    async submit() {
      const self = this;
      let valid = await self.$refs.validator.validate();

      if (valid) {
        let saveUrl = this.$route.params.id
          ? `${this.storeName}/update`
          : `${this.storeName}/create`;

        const payload = {
          ...this.data,
          users: this.selectAll
            ? this.usersCopy.map((user) => user._id)
            : this.data.users
        };

        self.$store
          .dispatch(saveUrl, payload)
          .then(function () {
            swal("Send Notification", "Successful!!", "success", {
              buttons: false,
              timer: 3000,
            });
            self.$router.push(self.buildRootUrl());
          })
          .catch(function (response) {
            swal("Error to Send Notification", "Error", "error", {
              buttons: false,
              timer: 3000,
            });
            for (const i in response.errors) {
              try {
                eval("self.$refs." + i + ".setErrors(response.errors[i]);");
              } catch (error) {
                //
              }
            }
          });
      }
    },
    clickSelectAll() {
      if (!this.selectAll) {
        if (this.usersCopy.length == 0) return;
        // Selecciona todos los usuarios de la lista actual (usersCopy)
        this.selectAll = true;
        this.data.users = [];//this.usersCopy.map((user) => user._id);
      } else {
        // Deselecciona todos
        this.data.users = [];
        this.selectAll = false;
      }
    },
    searchUsers() {
      if (!this.searchUser) {
        this.usersCopy = this.users;
      } else {
        this.usersCopy = this.users.filter((user) => {
          let full_name = `${user.name || ""} ${user.last_name || ""}`;
          return (
            full_name.toLowerCase().indexOf(this.searchUser.toLowerCase()) > -1
          );
        });
      }
    },
    onSelectedPicture(file) {
      const self = this;
      this.data.picture = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.picture = fr.result;
      };
      fr.onerror = function () {
        self.picture = "";
      };
      fr.readAsDataURL(this.data.picture);
    },
  },
};
</script>
<style>
.input-base .v-input__slot .v-label:has(.fixed-label) {
  top: 8px !important;
}
</style>